import { render } from "./NotificationBanner.vue?vue&type=template&id=4d5f6fcc&scoped=true"
import script from "./NotificationBanner.vue?vue&type=script&lang=js"
export * from "./NotificationBanner.vue?vue&type=script&lang=js"

import "./NotificationBanner.vue?vue&type=style&index=0&id=4d5f6fcc&lang=scss&scoped=true"

import exportComponent from "/home/cosmic/citadel-website/citadel-landing-dao-version-citadelone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5f6fcc"]])

export default __exports__